// Single source for contact details used across the site.
export const EMAIL = "munafhassan23@gmail.com";
export const LINKEDIN_URL = "https://www.linkedin.com/in/mmunaf/";
export const BEHANCE_URL = "https://www.behance.net/mmunaf";
export const DRIBBBLE_URL = "https://dribbble.com/mmunaf";
